import React, { useState } from "react";

import Landing from "./Landing";
import Login from "./Login";
import KredafiLanding from "../../kredafi/KredafiLanding";

import { isStandalonePwa } from "../../utils/platform";
import { applyKredafiDocumentMeta, isKredafiShell } from "../../utils/brand";

/**
 * Что показать человеку в браузере до входа.
 *
 * Если он пришёл по реферальной ссылке, прямо на страницу входа или открыл
 * установленное на рабочий стол PWA-приложение — сразу показываем экран входа.
 */

interface Props {
  onAuthenticated: (result: { userId: number; needsTelegram: boolean }) => void;
}

function shouldSkipLanding(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  const path = window.location.pathname;
  const params = new URLSearchParams(window.location.search);

  return (
    path.startsWith("/login") ||
    params.has("ref") ||
    params.has("login") ||
    params.get("source") === "pwa" ||
    isStandalonePwa()
  );
}

const AuthGate: React.FC<Props> = ({ onAuthenticated }) => {
  const [showLogin, setShowLogin] = useState(shouldSkipLanding);

  React.useEffect(() => {
    applyKredafiDocumentMeta();
  }, []);

  if (!showLogin) {
    if (isKredafiShell()) {
      return <KredafiLanding onEnter={() => setShowLogin(true)} />;
    }
    return <Landing onEnter={() => setShowLogin(true)} />;
  }

  return (
    <Login
      onAuthenticated={onAuthenticated}
      onBack={() => setShowLogin(false)}
    />
  );
};

export default AuthGate;
